const SDK_VERSION = '8.0.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
